<template>
  <section class="section-about" id="section-about">
    <div class="about__content">
      <div class="about__content_img-stack">
        <div
          class="about__content_img-stack--img about__content_img-stack--image1"
        ></div>
        <div
          class="about__content_img-stack--img about__content_img-stack--image2"
        ></div>
        <div
          class="about__content_img-stack--img about__content_img-stack--image3"
        ></div>
      </div>
      <div class="about__content--text">
        <div
          class="heading-tertiary color-tertiary-light u-margin-bottom-small"
        >
          Welcome!
        </div>
        <p class="paragraph about__paragraph u-margin-bottom-medium">
          I am a fun-spirited wife and mom who loves family, friends, and the
          art of photographing newborns!
        </p>
        <p class="paragraph about__paragraph u-margin-bottom-medium">
          Developing a specialty in newborn and baby photography is driven by my
          passion to authentically document your child's story before time and
          life add anything to their canvas. My style is simple and
          minimalistic, using natural light to softly highlight your baby's
          features through a series of gently guided poses. Ultimately, my
          purpose is to develop fine portraits you can look back on to remember
          those sweet baby moments that filled your heart with such love and
          joy.
        </p>

        <p class="paragraph about__paragraph u-margin-bottom-medium order1">
          EVERY NEW LIFE IS A MIRACLE!!
        </p>

        <p class="paragraph about__paragraph u-margin-bottom-medium">
          I would love an invitation to capture the wonder of yours!
        </p>

        <p>Blessings,</p>
        <img
          id="signature"
          src="../assets/IMAGES/jeanna-sig.png"
          alt="Jeanna Signature"
        />
      </div>
    </div>

    <div class="about__links">
      <span
        class="about__links--item"
        @click="(openInfo = !openInfo), disableBodyScroll()"
        >About</span
      >
      <span
        class="about__links--item"
        @click="(openPackages = !openPackages), disableBodyScroll()"
        >Packages</span
      >
      <!-- social -->
      <div class="about__links--social">
        <span style="padding-right: 1rem">Send me a Message! =></span>
        <a
          href="https://www.facebook.com/Jeanna-Chambers-Photography-112719030459095"
          class="about__links--social-icon"
          rel="noopener"
          target="_blank"
        >
          <img src="../assets/ICONS/fb.svg" alt="Facebook Icon Link" />
        </a>
      </div>
    </div>
    <Info
      v-if="openInfo"
      @close="(openInfo = false), enableBodyScroll()"
    ></Info>
    <Services
      v-if="openPackages"
      @close="(openPackages = false), enableBodyScroll()"
    ></Services>
  </section>
</template>

<script>
import Services from "../components/Services.vue";
import Info from "../components/Info.vue";
export default {
  name: "About",
  components: {
    Info,
    Services,
  },
  metaInfo: {
    titleTemplate: "%s | Newborn Photography",
  },
  data() {
    return {
      openInfo: false,
      openPackages: false,
      openContact: false,
    };
  },
  methods: {
    disableBodyScroll() {
      let body = document.body;
      body.classList.add("no-scroll");
    },
    enableBodyScroll() {
      let body = document.body;
      body.classList.remove("no-scroll");
    },
  },
};
</script>

<style lang="scss">
.no-scroll {
  overflow: hidden;
}

#signature {
  width: 15rem;
  padding-top: 2rem;
}

.about__content {
  display: flex;
  flex-flow: row;
  width: 100%;

  justify-content: space-around;
  // flex-flow: row wrap;

  @include respond(tab-port) {
    flex-direction: column;
    align-content: flex-start;
    margin: auto;
    padding: 0 1rem;
  }

  &--text {
    padding: 1.5rem;
    padding-left: 2.5rem;
    font-size: 1.6rem;
    width: 75%;
    height: 65rem;

    @media screen and (min-width: 600px) and (max-width: 899px) {
      height: 69rem;
      order: 1;
    }

    @media screen and (min-width: 900px) and (max-width: 1275px) {
      height: 72rem;
      order: 1;
    }

    @include respond(phone) {
      padding: 1.5rem 1rem;
      width: 100%;
      height: 80rem;
      order: 1;
    }
  }

  &_img-stack {
    justify-items: center;
    display: flex;
    flex-direction: column;
    width: 23.5vw;
    height: 100%;

    @include respond(tab-port) {
      padding: 1.5rem 1rem;
      flex-direction: column;
      width: 100%;
      order: 2;
    }

    &--img {
      height: 0;
      // OMG - this works
      padding-top: calc(680 / 1021 * 100%);
      min-width: 100%;
      align-self: center;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      // position: relative;
      background-color: rgba($color-black, 0.2);
      margin: 1rem 0;

      @include respond(tab-port) {
        min-width: 100%;
        // min-height: 15rem;
      }
    }

    &--image1 {
      background-image: url("../assets/IMAGES/img-stack-1.jpg");
    }

    &--image2 {
      background-image: url("../assets/IMAGES/img-stack-2.jpg");
    }

    &--image3 {
      background-image: url("../assets/IMAGES/img-stack-3.jpg");
    }
  }

  &--photo {
    box-shadow: 0 1.5rem 4rem rgba($color-black, 0.5);
    border-radius: 2px;
    z-index: 10;
    transition: all 0.2s;
    padding: 1rem;
    flex: 1 2 50%;
    max-width: 50%;
    align-self: flex-start;

    img {
      display: block;
      width: 50%;
      height: auto;
      margin: auto;
    }

    @include respond(tab-port) {
      box-shadow: 0 1.5 3rem rgba($color-black, 0.2);
      // padding: 0 1rem;
      // max-width: 100%;
    }

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 2.5rem 4rem rgba($color-black, 0.5);
      z-index: 20;
    }
  }

  &:hover &__photo:not(:hover) {
    transform: scale(0.95);
  }
}

.about__links {
  min-width: 90%;
  padding: 2.5rem;
  background-color: rgba($color-black, 0.2);
  font-size: 1.6rem;
  display: flex;
  margin: auto;
  position: relative;

  @include respond(tab-port) {
    padding: 1.5rem 1rem;
    margin-top: 1rem;
    width: 100vw;
    // height: 50%;
    order: 3;
  }

  &--item {
    transition: all 0.2s;
    cursor: pointer;
    padding: 1.5rem 4rem;
    color: rgba($color-white, 0.8);
    text-decoration: none;
    text-transform: uppercase;
    border-right: rgba($color-black, 0.2) solid 1px;

    @include respond(tab-port) {
      padding: 1.5rem 1rem;
      width: 50%;
      // height: 50%;
    }

    &:hover {
      border: rgba($color-black, 0.2) solid 1px;
      border-radius: 0.5rem;
      background-color: $color-white;
      color: rgba($color-black, 0.8);
      transform: scale(1.05);
      box-shadow: 0 2.5rem 4rem rgba($color-black, 0.5);
      z-index: 20;
    }

    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 100%;
      // border-radius: 10rem;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      transition: all 0.4s;
    }
  }

  &--social {
    display: flex;
    width: 100%;
    position: relative;
    flex-direction: row;
    justify-content: flex-end;
    background-color: transparent;

    @include respond(tab-port) {
      margin-right: 2rem;
      flex-direction: column;
      align-items: flex-end;
    }

    &-icon {
      & > img {
        width: 3rem;
        transition: all 0.2s;
        background-color: transparent;

        &:hover,
        &:active {
          width: 3rem;
          background-color: transparent;
          box-shadow: 0 1rem 2rem rgba($color-black, 0.5);
          transform: scale(1.001) translateY(-2px);
        }
      }
    }
  }
}

.no-pipe {
  border-right: none;
}
</style>

